document.addEventListener('alpine:init', () => {
  Alpine.data('Theme_Header', () => ({
    isStuck: false,
    overlayHeaderWithSticky: null,
    overlayTextColor: null,
    init() {
      this.overlayHeaderWithSticky =
        this.$root.dataset.overlayHeaderWithSticky === 'true';

      if (this.overlayHeaderWithSticky) {
        this.setUpOverlayWithSticky();
      }
    },
    setUpOverlayWithSticky() {
      const positionerEl = document.createElement('div');
      positionerEl.id = 'sticky-positioner';

      document.body.insertBefore(
        positionerEl,
        this.$root.closest('.shopify-section')
      );

      const observer = new IntersectionObserver(([e]) => {
        e.intersectionRatio === 0
          ? (this.isStuck = true)
          : (this.isStuck = false);
      });

      observer.observe(positionerEl);

      this.overlayTextColor = this.$root.dataset.overlayTextColorScheme;

      this.updateColorScheme(this.isStuck);

      this.$watch('isStuck', (value) => {
        this.updateColorScheme(value);
      });
    },
    updateColorScheme(isStuck) {
      if (isStuck) {
        this.$refs.header.setAttribute('data-color-scheme', '');
        this.$refs.header.classList.remove('bg-transparent');
        this.$refs.header.classList.add('bg-scheme-background');
      } else {
        this.$refs.header.setAttribute(
          'data-color-scheme',
          this.overlayTextColor
        );
        this.$refs.header.classList.remove('bg-scheme-background');
        this.$refs.header.classList.add('bg-transparent');
      }
    },
  }));
});

// 각 페이지에서 GNB 영역 링크 *반클릭 시,
// 페이지의 일부 영역이 GNB 하단에 미러링 되는 현상 발생.
// 상기 내용으로 인해, 아래 이벤트 생성
// *반클릭: 마우스로 GNB 링크 영역을 누른 후, 떼지 않고 다른 영역으로 이동할 경우
// => 해당 링크로 직접 이동하지 않고 클릭한 효과만 주는 경우
document.addEventListener('DOMContentLoaded', () => {
  const pcHeaderArea = document.querySelector('.shopify-section-group-header-group.section-header');

  // 페이지 로드 시 GNB 영역 overflow를 hidden으로 설정
  if (window.innerWidth >= 1024) {
    pcHeaderArea.style.overflow = 'hidden';
  }

  const buttons = document.querySelectorAll('.custom-header-style .header-bottom-wrap .menu-wrap > ul li > div button');

  buttons.forEach(button => {
    button.addEventListener('click', () => {
      // 클릭한 버튼의 다음 요소인 lnb-area 선택
      const lnbArea = button.nextElementSibling;

      // 현재 버튼 클릭 시 이전 버튼의 lnb-area 상태를 리셋
      buttons.forEach(btn => {
        if (btn !== button) {
          const prevLnbArea = btn.nextElementSibling;
          if (prevLnbArea) {
            prevLnbArea.style.display = 'none'; 
          }
        }
      });

      // 클릭한 버튼의 lnb-area display 확인
      if (lnbArea && getComputedStyle(lnbArea).display === 'none') {
        lnbArea.style.display = 'block'; // display를 block으로 변경
        pcHeaderArea.style.overflow = 'unset'; // overflow를 unset으로 변경
      } else if (lnbArea) {
        lnbArea.style.display = 'none'; // 다시 display를 none으로 변경
        pcHeaderArea.style.overflow = 'hidden'; // overflow를 hidden으로 변경
      }
    });
  });

  // country 컨테이너 클릭 이벤트 관련
  const checkCountrySelect = setInterval(() => {
    const countrySelect = document.querySelector('.header-top-wrap .country-container button');

    if (countrySelect) {
      clearInterval(checkCountrySelect); // 요소를 찾으면 interval 종료

      countrySelect.addEventListener('click', () => {
        // const options = document.querySelector('.header-top-wrap .buckscc-select-options');
        const options = document.querySelector('.header-top-wrap .country-container  #orbeFooterCountryList');
        if (options) {
          if (getComputedStyle(options).display === 'block') {
            pcHeaderArea.style.overflow = 'unset'; // display가 block일 경우 overflow를 unset으로 변경
          } else {
            pcHeaderArea.style.overflow = 'hidden'; // display가 none일 경우 overflow를 hidden으로 변경
          }
        } 
        // else {
        //   error
        // }
      });
    }
  }, 100); // 100ms 간격으로 체크

});









